import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import * as candidateActions from '../../Actions/CandidateActions';
import * as AddCandidateActions from '../../Actions/AddCandidateActions';
import CandidateRejectCardContainer from '../../Containers/CandidateRejectCard/CandidateRejectCardContainer';
import MinimizedRejectedIcon from '../../Icons/MinimizedRejectedIcon';
import MinimizedShortlistedIcon from '../../Icons/MinimizedShortlistedIcon';
import { getApiStatus } from '../../Reducers/ApiStatusReducer';
import { getConfig } from '../../Reducers/ConfigReducer';
import { getCandidateConnectStatus } from '../../Reducers/ConnectReducer';
import { checkAccessConfig, getSourceData } from '../../Utils/CandidateDrawerUtils';
import { getShouldNavigateToSubsegmentRedirectionTab } from '../../Utils/CandidateListUtils';
import CandidateBookmark from '../CandidateCard/CandidateBookmark';
import NewCandidateShortlistReject from '../CandidateCard/NewCandidateShortlistReject/NewCandidateShortlistReject';
import SubSegmentCandidateSourcedShortlistReject from '../CandidateCard/NewCandidateShortlistReject/SubSegmentCandidateSourcedShortlistReject';
import CandidateRejectCard from '../CandidateRejectCard/CandidateRejectCard';
import SocialIcon from '../Common/SocialIcon/SocialIcon';
import FetchContactWidgetWrapper from '../ConnectCard/FetchContactWidget/FetchContactWidgetWrapper';
import AtsPushComponent from './AtsPushComponent';
import styles from './Candidate360MinimizedCandidateHeaderWrapper.module.scss';
import Candidate360MinimizedCandidateInformationCard from './Candidate360MinimizedCandidateInformationCard';
import PushCandidateComponent from './PushCandidateComponent';

const mapStateToProps = (state, props) => ({
  candidateBookmarkApiStatus: getApiStatus(state, 'candidateBookmarkApiStatus'),
  candidateConnectStatus: getCandidateConnectStatus(state, props.candidate?.PersonId),
  userConfig: getConfig(state),
});

const mapsDispatchToProps = {
  updateCandidateBookmarkStatus: candidateActions.updateCandidateBookmarkStatus,
  recommendFavouriteCandidate: candidateActions.recommendFavouriteCandidate,
  toggleAssociateCandidateModalStatus: AddCandidateActions.toggleAssociateCandidateModalStatus,
};

function Candidate360MinimizedCandidateHeaderWrapper(props) {
  const {
    candidate,
    candidateType,
    onCandidateStatusChange,
    onCandidateReject,
    candidateContext = 'job',
    isPaidJobServiceEnabled,
    featureToggleList,
    jobId,
    candidateBookmarkApiStatus,
    updateCandidateBookmarkStatus,
    currentJobDetails,
    candidateConnectStatus,
    maskingConfig,
    getCandidateStatus,
    ignoreSimilar,
    version,
    pushCandToAtsStatus,
    atsConfig,
    showPushError,
    showContactInfoButton,
    onClickAtsPush,
    showPushCandidateButton,
    isCandidateDownloaded,
    onPushCandToAts,
    showCandidateDetailTabs,
    candidateId,
    activeTab,
    candidateStatusUpdate,
    userConfig,
    openInNewTab,
    isConnectTab,
    setAddSubsegmentModalStatus,
    selectedSubSegmentId,
    toggleAssociateCandidateModalStatus,
  } = props;

  const isAdvancedSearchV2Enabled = featureToggleList.AdvanceSearchV2.IsEnabled;

  const status = candidate?.Status;
  const isBookmarkVisible = candidateType !== 'quick-search';
  const isAddVisible =
    candidateContext === 'job' ||
    (candidateContext === 'segment' &&
      (status ? status.toLowerCase() === 'sourced' || status.toLowerCase() === 'rejected' : true));

  const isDeleteVisible =
    candidateContext === 'job' ||
    (candidateContext === 'segment' &&
      status &&
      (status.toLowerCase() === 'sourced' || status.toLowerCase() === 'shortlisted'));

  const { atsSource, pushedCandidateSource, originalSource } = getSourceData(candidate, version);
  const {
    isPushAllowed,
    isRecreateCandidateAllowed,
    isPushCandidateNotAllowedForAryaClosedJobs,
    isManualCandidateCreationAllowedForApplied,
  } = checkAccessConfig(candidate, atsConfig);
  const candidateBookmark = (
    <CandidateBookmark
      candidate={candidate}
      updateCandidateBookmarkStatus={updateCandidateBookmarkStatus}
      jobId={jobId}
      candidateBookmarkApiStatus={candidateBookmarkApiStatus}
      width={18}
      height={18}
    />
  );

  const shortlistedIcon = <MinimizedShortlistedIcon style={{ fontSize: '24px' }} />;
  const rejectedIcon = <MinimizedRejectedIcon />;

  const { shouldNavigateToSubsegment, targetJobId } = getShouldNavigateToSubsegmentRedirectionTab(
    window.location,
    featureToggleList
  );

  const candidateShortListReject = shouldNavigateToSubsegment ? (
    <SubSegmentCandidateSourcedShortlistReject
      candidate={candidate}
      jobId={targetJobId}
      zIndex={11111}
      placement="bottomLeft"
    />
  ) : (
    <NewCandidateShortlistReject
      isPaidJobServiceEnabled={isPaidJobServiceEnabled}
      activeTab={activeTab}
      featureToggleList={featureToggleList}
      onCandidateStatusChange={onCandidateStatusChange}
      candidateContext={candidateContext}
      isAddVisible={isAddVisible}
      isDeleteVisible={isDeleteVisible}
      candidateStatusUpdate={candidateStatusUpdate}
      candidate={candidate}
      size="medium"
      onCandidateReject={onCandidateReject}
      jobId={jobId}
      candidateId={candidateId}
      className={styles.enhancedShortlistContainer}
      shortlistedIcon={shortlistedIcon}
      rejectedIcon={rejectedIcon}
      iconStyle={{ fontSize: '24px', width: '24px', height: '24px' }}
      candidateTransferIconClassName={styles.candidateTransferIcon}
      iconHeight={24}
      version={version}
      setAddSubsegmentModalStatus={setAddSubsegmentModalStatus}
      selectedSubSegmentId={selectedSubSegmentId}
      openInNewTab={openInNewTab}
      toggleAssociateCandidateModalStatus={toggleAssociateCandidateModalStatus}
    />
  );

  const socialIconComponent = <SocialIcon candidate={candidate} isActive={maskingConfig?.IsActive} />;

  const candidatePushComponentV2 =
    version === 'ats' ? (
      <AtsPushComponent
        candidate={candidate}
        atsSource={atsSource}
        onPushCandToAts={onPushCandToAts}
        isLoading={pushCandToAtsStatus === 'INPROGRESS'}
        isPushAllowed={isPushAllowed}
        onClickAtsPush={onClickAtsPush}
        isCandidateDownloaded={isCandidateDownloaded}
        showContactInfoButton={showContactInfoButton}
        showPushCandidateButton={showPushCandidateButton}
        originalSource={originalSource}
        showPushError={showPushError}
      />
    ) : (
      <PushCandidateComponent
        atsSource={pushedCandidateSource}
        onPushCandToAts={onPushCandToAts}
        loading={pushCandToAtsStatus === 'INPROGRESS'}
        isPushAllowed={isPushAllowed}
        jobStatus={currentJobDetails?.Status}
        aryaJobStatus={currentJobDetails?.AryaStatus}
        isPushCandidateNotAllowedForAryaClosedJobs={isPushCandidateNotAllowedForAryaClosedJobs}
        isManualCandidateCreationAllowedForApplied={isManualCandidateCreationAllowedForApplied}
        appliedtime={candidate.AppliedTime}
        showContactInfoButton={showContactInfoButton}
        showPushCandidateButton={showPushCandidateButton}
        isRecreateCandidateAllowed={isRecreateCandidateAllowed}
      />
    );

  const displayedPushComponent = <div className={styles.candidatePushV2}>{candidatePushComponentV2}</div>;
  const ConditionalCandidateRejectCard =
    isAdvancedSearchV2Enabled && !isConnectTab ? (
      <CandidateRejectCardContainer
        key={_.get(candidate, 'Id')}
        candidate={candidate}
        onCandidateReject={onCandidateReject}
        onCandidateStatusChange={onCandidateStatusChange}
        ignoreSimilar={ignoreSimilar}
        size="small"
        isPaidJobServiceEnabled={isPaidJobServiceEnabled}
        isCandidateListRejectCard
        jobId={jobId}
        candidateContext={candidateContext}
        version={version}
        openInNewTab={openInNewTab}
        featureToggleList={featureToggleList}
      />
    ) : (
      <CandidateRejectCard
        key={_.get(candidate, 'Id')}
        candidate={candidate}
        onCandidateReject={onCandidateReject}
        onCandidateStatusChange={onCandidateStatusChange}
        ignoreSimilar={ignoreSimilar}
        size="small"
        isPaidJobServiceEnabled={isPaidJobServiceEnabled}
        isCandidateListRejectCard
        jobId={jobId}
        candidateContext={candidateContext}
        version={version}
        openInNewTab={openInNewTab}
        featureToggleList={featureToggleList}
        isConnectTab={isConnectTab}
      />
    );

  const { candidateStatus } = getCandidateStatus(candidate, featureToggleList, currentJobDetails?.JobGuid);

  return (
    <div className={styles.minimizedCandidateHeader}>
      {candidateContext === 'segment' || !candidate.drawerRejectFlag ? (
        <>
          <div className={styles.candidateInfoAndContact}>
            <Candidate360MinimizedCandidateInformationCard
              candidate={candidate}
              featureToggleList={featureToggleList}
              userConfig={userConfig}
              atsConfig={atsConfig}
              jobGuid={currentJobDetails?.JobGuid}
            />
            <div className={styles.candidateConnect}>
              {showCandidateDetailTabs ? (
                <FetchContactWidgetWrapper
                  fetchContactStatus={candidate.fetchContactStatus}
                  currentJobDetails={currentJobDetails}
                  candidate={candidate}
                  availableProviders={candidateConnectStatus?.Contact?.AvailableProviders}
                  contact={candidateConnectStatus?.Contact ?? {}}
                />
              ) : null}
            </div>
          </div>
          <div className={styles.bookmarkAndCandidateActions}>
            <div className={styles.candidateActionIcons}>
              <div>{candidateStatus}</div>
              <div className={styles.pushCandidateIcon}>{displayedPushComponent}</div>
              {socialIconComponent}
              {isBookmarkVisible ? candidateBookmark : null}
            </div>
            {candidateShortListReject}
          </div>
        </>
      ) : (
        ConditionalCandidateRejectCard
      )}
    </div>
  );
}
export default connect(mapStateToProps, mapsDispatchToProps)(Candidate360MinimizedCandidateHeaderWrapper);
export { Candidate360MinimizedCandidateHeaderWrapper as Candidate360MinimizedCandidateHeaderWrapperWithoutStore };
